import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { currentRole } from "@/lib/pb";

/**
 * Ported from portal-ui/app/(support)/layout.tsx.
 * Pathless layout that gates child routes on role === "support".
 * Auth itself is already enforced by the parent /_app route, so we
 * only need to verify the role and bounce non-support users home.
 */
export const Route = createFileRoute("/_app/_support")({
  beforeLoad: () => {
    if (currentRole() !== "support") {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: () => <Outlet />,
});
